import { render, staticRenderFns } from "./Commitment.vue?vue&type=template&id=1db0c8fe&scoped=true"
import script from "./Commitment.vue?vue&type=script&lang=js"
export * from "./Commitment.vue?vue&type=script&lang=js"
import style0 from "./Commitment.vue?vue&type=style&index=0&id=1db0c8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db0c8fe",
  null
  
)

export default component.exports